import React, { useState } from 'react';
import ArrowIcon from '../assets/images/ArrowIconWhite.svg';
import BgImage from '../assets/images/top-cover-bg.png';
import BookADemo from './BookADemo';

function TopSection() {
  const [visible, setVisible] = useState(false);
  return (
    <section className='topSection'>
      <article>
        <h1>Give your brand the online presence it deserves</h1>
        <p>With TheDocPro, you can strengthen your digital presence by promoting branded content, product releases, and a lot more...</p>
        <button onClick={() => setVisible(true)} className='bookDemoButton'>
          Send Your Query <img src={ArrowIcon} alt />
        </button>
      </article>
      <BookADemo visible={visible} setVisible={setVisible} />
    </section>
  );
}

export default TopSection;
